(function () {
  var VERIFY_GA_CONTENT_NAME = 'verify';

  function trackVerifySelectContent(contentType, buttonName) {
    var typeLabel = (contentType || '').trim();
    var buttonLabel = (buttonName || '').trim();
    if (!typeLabel || !buttonLabel) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: typeLabel,
        content_name: VERIFY_GA_CONTENT_NAME,
        button_name: buttonLabel
      }
    });
  }

  function initVerifyGaTracking(root) {
    if (root.dataset.verifyGaBound === 'true') return;
    root.dataset.verifyGaBound = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target.closest('.section-open-eh-stu-verify__btn[data-verify-ga-track="verify"]');
      if (!button || !root.contains(button)) return;

      trackVerifySelectContent(
        button.getAttribute('data-verify-ga-content-type'),
        button.getAttribute('data-verify-ga-button-name')
      );
    });
  }

  function initTooltip(wrap) {
    if (!wrap || wrap.dataset.tooltipInitialized === 'true') return;
    wrap.dataset.tooltipInitialized = 'true';

    var trigger = wrap.querySelector('[data-verify-info-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      if (!window.matchMedia('(hover: none)').matches) return;
      event.preventDefault();
      wrap.classList.toggle('is-open');
    });

    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) {
        wrap.classList.remove('is-open');
      }
    });
  }

  function initRoot(root) {
    initVerifyGaTracking(root);
    root.querySelectorAll('[data-verify-info-wrap]').forEach(initTooltip);
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-verify-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-verify-root]');
    if (root) {
      delete root.dataset.verifyGaBound;
      root.querySelectorAll('[data-verify-info-wrap]').forEach(function (wrap) {
        delete wrap.dataset.tooltipInitialized;
      });
      initRoot(root);
    }
  });
})();
